// -----------------------------------------------------------------------------
// Globale Variablen
// -----------------------------------------------------------------------------

export default {
  basePath: $('.js-body').attr('data-basepath')
};
